import React from 'react';
import { DollarSignIcon, UsersIcon, ArrowUpIcon, PercentIcon, ArrowUpRightIcon } from 'lucide-react';
export const CaseStudiesSection = () => {
  const benefits = [{
    icon: <DollarSignIcon size={24} data-id="element-50" />,
    title: 'Increased Revenue',
    description: 'Our clients typically see 30-45% increase in sponsorship revenue within the first event cycle.'
  }, {
    icon: <UsersIcon size={24} data-id="element-51" />,
    title: 'Higher Retention',
    description: '85% sponsor retention rate compared to industry average of 60%.'
  }, {
    icon: <PercentIcon size={24} data-id="element-52" />,
    title: 'Better ROI',
    description: 'Outsourced model delivers 3-4x ROI compared to in-house sales teams.'
  }, {
    icon: <ArrowUpIcon size={24} data-id="element-53" />,
    title: 'Upmarket Movement',
    description: 'Access to enterprise-level sponsors typically out of reach for most events.'
  }];
  const testimonials = [{
    quote: 'They secured 12 new sponsors for our tech conference, increasing our revenue by 42% year-over-year.',
    author: 'Sarah Johnson',
    title: 'Event Director, TechSummit Global'
  }, {
    quote: 'Their data-driven approach helped us identify and secure sponsors we never would have considered otherwise.',
    author: 'Michael Rodriguez',
    title: 'CEO, HealthTech Conference'
  }, {
    quote: 'Not only did they exceed our sponsorship targets, but the quality of sponsors perfectly matched our audience.',
    author: 'Jennifer Chen',
    title: 'Marketing Director, FinInnovate Summit'
  }];
  return <section id="results" className="py-24 bg-[#f5f5f5] text-black relative" data-id="element-54">
      <div className="absolute top-0 left-0 w-24 h-24 bg-[#FF7A39]/40 rounded-br-3xl" data-id="element-55"></div>
      <div className="container mx-auto px-6" data-id="element-56">
        <div className="mb-5" data-id="element-57">
          <span className="text-black font-medium inline-flex items-center gap-2 bg-white/70 px-4 py-1.5 rounded-full shadow-sm" data-id="element-58">
            <div className="w-6 h-6 bg-[#FF7A39] rounded-sm" data-id="element-59"></div>
            Results
          </span>
        </div>
        <div className="mb-16" data-id="element-60">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black" data-id="element-61">
            100+ Event & Conference organizers trusted us to improve their{' '}
            <span className="font-serif italic text-[#FF7A39]" data-id="element-62">
              sponsorship revenue
            </span>
          </h2>
          <p className="text-xl text-black/80 max-w-2xl leading-relaxed" data-id="element-63">
            More than 100 B2B companies worldwide trusted us to improve their
            marketing engine and sponsorship ROI.
          </p>
        </div>
        {/* Featured Case Study */}
        <div className="mb-20 bg-white rounded-lg overflow-hidden shadow-lg border border-gray-100" data-id="element-64">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-0" data-id="element-65">
            <div className="p-10 flex flex-col justify-center" data-id="element-66">
              <h3 className="text-2xl font-bold mb-5 text-black" data-id="element-67">
                Premium Sponsorship Activations
              </h3>
              <p className="text-black/70 mb-8 leading-relaxed" data-id="element-68">
                We helped secure a luxury automotive brand as a premium sponsor,
                creating a high-impact activation that generated significant
                buzz and ROI for both the sponsor and event.
              </p>
              <div className="space-y-3 mb-8" data-id="element-69">
                <div className="flex items-start" data-id="element-70">
                  <span className="text-[#FF7A39] mr-2 mt-1 font-bold" data-id="element-71">•</span>
                  <span className="text-black/70" data-id="element-72">
                    42% increase in sponsor engagement
                  </span>
                </div>
                <div className="flex items-start" data-id="element-73">
                  <span className="text-[#FF7A39] mr-2 mt-1 font-bold" data-id="element-74">•</span>
                  <span className="text-black/70" data-id="element-75">
                    3.5x ROI for the sponsor
                  </span>
                </div>
                <div className="flex items-start" data-id="element-76">
                  <span className="text-[#FF7A39] mr-2 mt-1 font-bold" data-id="element-77">•</span>
                  <span className="text-black/70" data-id="element-78">
                    Renewed partnership for 3 consecutive years
                  </span>
                </div>
              </div>
              <a href="#contact" className="inline-flex items-center gap-2 text-[#FF7A39] font-medium hover:text-[#FF7A39]/80 transition-colors" data-id="element-79">
                Learn how we can create similar results for you{' '}
                <ArrowUpRightIcon size={18} data-id="element-80" />
              </a>
            </div>
            <div className="h-full min-h-[300px] md:min-h-0" data-id="element-81">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/61FExVajLUUdxUg7L7j1jj/20230127_105102.jpg" alt="Ferrari sponsorship activation" className="w-full h-full object-cover" data-id="element-82" />
            </div>
          </div>
        </div>
        {/* Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-83">
          {testimonials.map((item, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-all border border-gray-100 flex flex-col h-full transform hover:-translate-y-1 duration-300" data-id="element-84">
              <div className="mb-6" data-id="element-85">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hkWGY44RQgzNCHJG7k4dv9/Logo_Icon.png" alt={`${item.author}'s company`} className="h-10" data-id="element-86" />
              </div>
              <p className="text-black/70 italic mb-6 flex-grow leading-relaxed" data-id="element-87">
                "{item.quote}"
              </p>
              <div data-id="element-88">
                <p className="font-bold text-black" data-id="element-89">{item.author}</p>
                <p className="text-black/70" data-id="element-90">{item.title}</p>
              </div>
            </div>)}
        </div>
        {/* Benefits */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-20" data-id="element-91">
          {benefits.map((item, index) => <div key={index} className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-all border border-gray-100 h-full flex flex-col transform hover:-translate-y-1 duration-300" data-id="element-92">
              <div className="flex items-center justify-center mb-5 text-[#FF7A39] bg-[#FF7A39]/10 p-3 rounded-full w-fit" data-id="element-93">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-black mb-3" data-id="element-94">
                {item.title}
              </h3>
              <p className="text-black/70 flex-grow leading-relaxed" data-id="element-95">
                {item.description}
              </p>
            </div>)}
        </div>
        {/* Key Metrics */}
        <div className="bg-white rounded-lg p-10 mb-16 border border-gray-100 shadow-md" data-id="element-96">
          <h3 className="text-2xl font-bold mb-10 text-center text-black" data-id="element-97">
            Key Performance Metrics
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-98">
            <div className="bg-[#f5f5f5] p-8 rounded-lg flex flex-col items-center border border-gray-100 shadow-sm hover:shadow-md transition-all transform hover:-translate-y-1 duration-300" data-id="element-99">
              <div className="text-5xl font-bold mb-3 text-[#FF7A39]" data-id="element-100">42%</div>
              <div className="text-center text-black/70 font-medium" data-id="element-101">
                Average Increase in Sponsorship Revenue
              </div>
            </div>
            <div className="bg-[#f5f5f5] p-8 rounded-lg flex flex-col items-center border border-gray-100 shadow-sm hover:shadow-md transition-all transform hover:-translate-y-1 duration-300" data-id="element-102">
              <div className="text-5xl font-bold mb-3 text-[#FF7A39]" data-id="element-103">85%</div>
              <div className="text-center text-black/70 font-medium" data-id="element-104">
                Sponsor Retention Rate
              </div>
            </div>
            <div className="bg-[#f5f5f5] p-8 rounded-lg flex flex-col items-center border border-gray-100 shadow-sm hover:shadow-md transition-all transform hover:-translate-y-1 duration-300" data-id="element-105">
              <div className="text-5xl font-bold mb-3 text-[#FF7A39]" data-id="element-106">3.8x</div>
              <div className="text-center text-black/70 font-medium" data-id="element-107">
                Average ROI on Our Services
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};